<template>
	<component :is="view" />
</template>

<script>
import { computed, defineComponent } from 'vue';
import { useStore, authUser } from '../store';
import Faelle from './Faelle.vue';
import FaellePublic from './FaellePublic.vue';
import FaelleVorstand from './FaelleVorstand.vue';
import FaelleWerberat from './FaelleWerberat.vue';

export default defineComponent({
	name: 'FaelleWrapper',
	components: {
		Faelle,
		FaellePublic,
	},
	setup() {
		const store = useStore();
		const loggedin = computed(() => store.state.loggedin);
		const user = computed(() => store.state.user);
		const isLoggedIn = loggedin.value && user.value;

		const view = computed(() => {
			if (!isLoggedIn) {
				return FaellePublic;
			}
			const authUserRoles = authUser.value.roles.map((role) => role.name);
			if (authUserRoles.includes('Vorstand')) {
				return FaelleVorstand;
			} else if (
				authUserRoles.includes('Werberat') ||
				authUserRoles.includes('Junger Werberat') ||
				authUserRoles.includes('Kleiner Senat A') ||
				authUserRoles.includes('Kleiner Senat B')
			) {
				return FaelleWerberat;
			}
			return Faelle;
		});

		return {
			view,
		};
	},
});
</script>
